import templateUrl from 'emun.map/map-view.htm'
import AutoQuery from 'servicestack/auto-query/auto-query'
import basicController from 'servicestack/basic.controller.properties'
import resolve from 'ioc/resolve'
import modals from 'webmodals/modals'

class MapViewController  {
    constructor() {
        const $ctrl = this;
        basicController($ctrl);

		$ctrl.mapObject = {
			scope: 'usa',
		  options: {
			width: 1110,
			legendHeight: 60,
			labels: true,
			zoomable: true
		  },
		  geographyConfig: {
			highlighBorderColor: '#EAA9A8',
			highlighBorderWidth: 2,
			popupTemplate: function (geography, data) {
				return '<div class="hoverinfo">' + geography.properties.name + '<br/>YTD Sales: ' +  data.sales + ' '
			}
		  },
		  fills: {
			'HIGH': '#CC4731',
			'MEDIUM': '#306596',
			'LOW': '#667FAF',
			'defaultFill': '#DDDDDD'
		  },
		  data: {
		  }
		}
		$ctrl.mapPlugins = {
			customLegend: function (layer, data, options) {
				var html = ['<ul class="list-inline">'],
					label = '';
				for (var fillKey in this.options.fills) {
					html.push('<li class="key" ',
						'style="border-top: 10px solid ' + this.options.fills[fillKey] + '">',
						fillKey == 'HIGH' ? '> 100000' : fillKey == 'MEDIUM' ? '< 100000' : fillKey == 'LOW' ? '< 50000' : 'NONE',
						'</li>');
				}
				html.push('</ul>');
				d3.select(this.options.element).append('div')
					.attr('class', 'datamaps-legend')
					.html(html.join(''));
			}
		};
		$ctrl.salesQuery = new AutoQuery({
            url: 'QuerySalesYOYTotals.json?Sum=TotalSalesMonthToDate,TotalSalesQuarterToDate,TotalSalesYearToDate,TotalSalesMonthToDateLastYear,TotalSalesQuarterToDateLastYear,TotalSalesYearToDateLastYear&GroupBy=SalesRepState',
            autoLoad: true,
            onLoaded: function(args) {
				args.results.forEach(function (res) {
					$ctrl.mapObject.data[res.salesRepState] = {
						"fillKey": res.sumTotalSalesYearToDate <= 50000 ? "LOW" : res.sumTotalSalesYearToDate <= 100000 ? "MEDIUM" : "HIGH",
						"sales": "$" + Math.round(res.sumTotalSalesYearToDate)
					}
                });
			}
		});
	}
}

let MapView = {
    controller: MapViewController,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl;
    }
}

export default MapView;